import React from 'react';
import { HpRewardBadge } from '@hpstellar/core';

import withPageComponents from '../../../../page/components/with-page-components';
import AddOnPrice from '../../../../product/components/product-configurations/addon-price';
import ProductPriceBlock from '../../../../product/components/product-price/product-price-block';
import PriceBlock from '../../price-block';
import { useCTOConfigPrice } from '../../../../hooks/useProductPrice';
import useTemplateTheme from '../../../../hooks/useTemplateTheme';

const PriceContainer = ({
    productInitial,
    pdpOfferCatgories,
    hidePrice,
    className,
    priceProps,
    hasPriceSeoText = true,
    msrpTooltipProps,
}) => {
    const { discount } = pdpOfferCatgories || {};
    const ctoConfig = useCTOConfigPrice(productInitial);
    if (!productInitial) return null;

    const { eol } = productInitial;
    const { price: configPrice, isNotDefaultConfig } = ctoConfig || {};
    const { typography } = useTemplateTheme(['typography']);
    const { primaryColor } = typography || {};
    const violatorProps = { visId: true, backgroundColor: primaryColor };
    return (
        !eol && (
            <div className={className}>
                {!hidePrice && (
                    <AddOnPrice sku={productInitial.sku}>
                        {({ addOnPrice }) => {
                            return (
                                <ProductPriceBlock
                                    className={`pdp-price`}
                                    product={productInitial}
                                    addOnPrice={addOnPrice}
                                    displayPercentageDiscount={true}
                                    priceTag="h3"
                                    hasPriceSeoText={hasPriceSeoText}
                                    disableCustomSaleText={true}
                                    offers={discount}
                                    violatorProps={violatorProps}
                                >
                                    {props => (
                                        <PriceBlock
                                            {...props}
                                            {...(priceProps || {})}
                                            configPrice={isNotDefaultConfig && configPrice}
                                            violatorBgColor={primaryColor}
                                            msrpTooltipProps={msrpTooltipProps}
                                        />
                                    )}
                                </ProductPriceBlock>
                            );
                        }}
                    </AddOnPrice>
                )}
            </div>
        )
    );
};

export default withPageComponents(PriceContainer, {
    components: ['productInitial', 'pdpOfferCatgories'],
});
